import { useState } from 'react';
import { faqData } from '@/mocks/faq';

export default function FAQSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);

  return (
    <section id="faq" className="bg-background-100 py-14 md:py-18" aria-labelledby="faq-title">
      <div className="max-w-3xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 id="faq-title" className="text-2xl md:text-3xl font-heading font-bold text-foreground-900">
            常见问题
          </h2>
          <p className="mt-3 text-foreground-600 text-sm md:text-base">
            关于韩漫大全，您可能想了解的问题
          </p>
        </div>

        <div className="space-y-3" itemScope itemType="https://schema.org/FAQPage">
          {faqData.map((faq, index) => (
            <div
              key={index}
              className="bg-background-50 border border-background-200/70 rounded-lg overflow-hidden"
              itemScope
              itemProp="mainEntity"
              itemType="https://schema.org/Question"
            >
              <button
                className="w-full flex items-center justify-between px-5 py-4 text-left hover:bg-background-100/50 transition-colors duration-200"
                onClick={() => setOpenIndex(openIndex === index ? null : index)}
              >
                <h3 className="text-sm md:text-base font-medium text-foreground-900 pr-4" itemProp="name">
                  {faq.question}
                </h3>
                <i
                  className={`ri-arrow-down-s-line text-foreground-500 transition-transform duration-300 flex-shrink-0 ${
                    openIndex === index ? 'rotate-180' : ''
                  }`}
                ></i>
              </button>
              <div
                className={`overflow-hidden transition-all duration-300 ${
                  openIndex === index ? 'max-h-96 pb-5 px-5' : 'max-h-0'
                }`}
                itemScope
                itemProp="acceptedAnswer"
                itemType="https://schema.org/Answer"
              >
                <p className="text-sm text-foreground-600 leading-relaxed" itemProp="text">
                  {faq.answer}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}